


















































import { DashboardService } from "@/services/dashboard.service";
import { dateHoraMinuto, moeda } from "@/shared/filters";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";

@Component({
  filters: { dateHoraMinuto, moeda }
})
export default class PlanosContratadosTable extends Mixins(GlobalMixin) {
  listaPlanos: string[] = [];
  loadingPlanos = false;
  intervalId = 0;

  @Prop() readonly date!: string | null;

  mounted() {
    this.onChangeDate();
  }

  @Watch("date")
  onChangeDate() {
    this.carregarListaPlanos();
    this.intervalId = setInterval(() => this.carregarListaPlanos(), 10000);
  }

  async carregarListaPlanos() {
    this.loadingPlanos = true;
    if (this.date) {
      this.listaPlanos = await DashboardService.ListaPlanos(this.date).finally(
        () => (this.loadingPlanos = false)
      );
    }
  }

  beforeDestroy() {
    clearInterval(this.intervalId);
  }
}
